import { reactive, toRefs, provide, inject, ref, computed } from "@vue/composition-api";
import { actions as appActions, state as appState } from "@/store/modules/app";
import { actions as dialogActions } from "@/store/modules/dialog";
import { setCookie, getCookie } from "@/helpers/helpers";
import axios from "axios";
import { $t } from "@/i18n";
import router from "../../router";

const PROTOCOL = process.env.VUE_APP_WS_PROTOCOL ? process.env.VUE_APP_WS_PROTOCOL : "";
const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
const BASE_URL = `${PROTOCOL}://${HOST}`;

export const state = reactive({
    reconnect_counter: 0,
    no_reconnect: false,
    import_ws: null,
    currentImport: {},
    latestImport: {},
    import_step: 1,
    email: null,
    password: null,
    api_country: null,
    import_ready: false,
    api_countries: [
        {
            text: $t('Estonia'),
            value: "ee",
        },
        {
            text: $t('Finland'),
            value: "fi",
        },
        {
            text: $t('Poland'),
            value: "pl",
        }
    ]
});

export const actions = {
    connectWs () {
        setCookie("ongoing_import", 1);
        if (state.import_ws) return
        state.import_ws = new WebSocket("{0}/ws/import".format(BASE_URL));

        state.import_ws.onopen = function () {
            console.log("Import WebSocket: connected");
            state.reconnect_counter = 0;
        };

        state.import_ws.onmessage = function (ev) {

            let data = JSON.parse(ev.data);
            state.currentImport = data
            state.latestImport = data
            actions.setImportStep(4)
        };

        state.import_ws.onclose = function () {
            if(state.no_reconnect){
                console.log("Import WebSocket: connection closed");
                state.no_reconnect = false
                return
            }
            console.log("Import WebSocket: connection lost");
            if (state.reconnect_counter >= appState.reconnect_max_tries) {
                appActions.showGlobalConnectionLost();
            } else {
                state.reconnect_counter++;
                setTimeout(function () {
                    console.log("Import WebSocket: reconnecting...({0})".format(state.reconnect_counter));
                    actions.connectWs();
                }, appState.reconnect_wait);
            }
        };
    },
    closeWs(){
        setCookie("ongoing_import", 0);
        if (!state.import_ws) return
        state.no_reconnect = true
        state.import_ws.close()
        state.import_ws = null
    },
    isWebsocketActive(){
        return ref(!!state.import_ws)
    },
    setCurrentImport(value){
        state.currentImport = value
    },
    setLatestImport(value){
        state.latestImport = value
    },
    async startMeritAktivaImport(payload){
        return await axios.post('/import/merit_aktiva', payload)
    },
    async getOngoingImportStatus(account_id){
        let response;
        response = await axios.get('/import/merit_aktiva/status', { params: { account_id:account_id }})
        return response.data
    },
    setImportStep(step, payload){
        state.import_step = step
        state.import_ready = false
        actions.closeWs()
        if (step === 1){
            state.email = null
            state.password = null
        } else if (step === 2){
            state.email = payload.email
            state.password = payload.password
            state.api_country = payload.api_country
        } else if (step === 3){
            actions.connectWs()
        } else if (step === 4){
            state.import_ready = true
        }
    },
    async validateCredentials({ email, password, api_country }){
        let response = await axios.post('/import/merit_aktiva/test_connection', { email: email, password: password , api_country:api_country } )
        return response.data
    }


};

export const key = Symbol("MeritAktivaWsStore");

export const provideMeritAktivaWs = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    });
};

if (parseInt(getCookie('ongoing_import')) === 1){
    actions.connectWs()
} else {
    actions.closeWs()
}

//appState.web_socket_connectors.push(actions.connectWs);

export default () => inject(key);
